import React from "react";
import ForgotPassword from "./ForgotPassword";

const ForgotPasswordWithQuery = props => (
  <ForgotPassword title={"Forgot Password"} {...props} />
);

export default ForgotPasswordWithQuery;
